import React, { useState, useEffect } from "react";
import { Desktop } from "../components/Desktop/index";

export const Home: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Simulate loading time
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 2000);

        return () => clearTimeout(timer);
    }, []);

    if (isLoading) {
        return (
            <div className="h-screen w-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-blue-700">
                <div className="text-white text-2xl">Loading...</div>
            </div>
        );
    }

    return <Desktop />;
};
